export const COOKIE_CONSENT_NAME = 'cookie_consent_given';
export const COOKIE_CONSENT_VALUE = 'yes';
export const THEME_MODE_NAME = 'theme_mode';
export const FONTS_LOADED_NAME = 'fonts_loaded';
export const FONTS_LOADED_VALUE = 'yes';

export const setCookie = (name, value, days) => {
  const d = new Date();

  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = `${name}=${value};path=/;expires=${d.toGMTString()}`;
};

export const getCookie = name => {
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);

  return v ? v[2] : null;
};

export const deleteCookie = name => setCookie(name, '', -1);
